import React, { useState, useEffect } from 'react';

import { PlayButton } from '../PlayButton';
import { AudioSingleton } from '../../core/AudioSingleton';
import { observer } from 'mobx-react';

import './style.css';

export const PlayBar = observer(
	({
		playBarStore,
		playButtonIsVisible,
		onPlay,
		buttonDisabled = false,
		isSpot = false
	}) => {
		const [volRange, setvolRange] = useState(1);
		const [oldState, setOldState] = useState(1);
		const [volState, setVolState] = useState(false);
		const [icon, setIcon] = useState("glyphicon glyphicon-volume-up");
		const [margin, setMargin] = useState(12);

		const handleChange = ({ target }) => {

			setvolRange(target.value);
			setOldState(target.value);
			if (target.value <= 0.5) {
				setIcon("fas fa-volume-down")
			}
			if (target.value >= 0.6) {
				setIcon("fas fa-volume-up")
			}

			AudioSingleton.setVolume(target.value);
		}

		const clickMute = () => {
			setVolState(!volState);

			if (volState === false) {
				setvolRange(0);
				setIcon("fas fa-volume-off")
			} else {
				setvolRange(oldState);
				if (oldState >= 0.6) {
					setIcon("fas fa-volume-up")
				} else {
					setIcon("fas fa-volume-down")
				}
			}
			AudioSingleton.mute();
		}

		useEffect(() => {
			const sUsrAg = navigator.userAgent;
			if (sUsrAg.indexOf("Firefox") > -1) {
				setMargin(0);
			}
		}, [])

		return (
			<>
				<div className='test'>

					<PlayButton
						isSpot={isSpot}
						isPlaying={playBarStore.isPlaying}
						visible={playButtonIsVisible}
						disabled={buttonDisabled}
						onClick={onPlay}
					/>

				</div>
				<div
					id='volumen'
					className='volumen'
				>
					<i
						className={icon}
						onClick={clickMute}
					>
					</i>
					<input
						type="range"
						min={0}
						max={1}
						step={0.02}
						value={volRange}
						onChange={handleChange}
						style={{ marginTop: margin }}
					/>
				</div>
			</>
		);
	}
);